import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "@/services/api/apiRequest";

export type SupportMessage = {
  id: number;
  subject: string;
  body: string;
  status: "new" | "answered" | "closed";
  created_at: string;
};

/** What this member has already asked the administrators. */
export function useMySupportMessages() {
  return useQuery<{ messages: SupportMessage[] }>({
    queryKey: ["afell", "support", "mine"],
    queryFn: () => apiRequest("/afell/support/"),
  });
}

/** Write to the administrators. Every admin is emailed it, with the member's
 *  own address as the Reply-To, so their answer arrives as an ordinary reply. */
export function useSubmitSupportMessage() {
  const queryClient = useQueryClient();
  return useMutation<
    { id: number; status: string },
    Error,
    { subject: string; body: string }
  >({
    mutationFn: (payload) => apiRequest("/afell/support/", "POST", payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["afell", "support"] });
    },
  });
}
